export const stringsKey = "MessageTitle";
export const englishStrings = {
	messageTitle: "Message Title",
};
